import { render, staticRenderFns } from "./top-layout.vue?vue&type=template&id=79cffbc8&scoped=true"
import script from "./top-layout.vue?vue&type=script&lang=js"
export * from "./top-layout.vue?vue&type=script&lang=js"
import style0 from "./top-layout.vue?vue&type=style&index=0&id=79cffbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cffbc8",
  null
  
)

export default component.exports